import { ImageConstants } from '../constants/constants';
import imageCache from "./image-cache";

export function getThemeImageSource(image, categoryId) {


    let theme = '';

    switch (categoryId) {

        case "1": theme = `purple`;
            break;

        case "2": theme = `indigo`;
            break;

        case "3": theme = `orange`;
            break;

        case "4": theme = `skyblue`;
            break;

        case "5": theme = `blue`;
            break;

        case "6": theme = `yellow`;
            break;

        default:
            theme = `purple`;
            break;
    }


    return imageCache[theme][image];

}


export function getImageSource(image) {

    let imageSrc;

    switch (image) {
        case ImageConstants.MULTI_STEP_IMAGE:
            imageSrc = require("../assets/images/multi_step_image.png")
            break;
        case ImageConstants.ANGLE_DOWN_ARROW:
            imageSrc = require("../assets/images/angle-down-arrow.png")
            break;
        case ImageConstants.ANGLE_UP_ARROW:
            imageSrc = require("../assets/images/angle-up-arrow.png")
            break;
        case ImageConstants.YEELOW_BULLET:
            imageSrc = require("../assets/images/yellow-bullet.png")
            break;
        case ImageConstants.TEACHER_CLICKER_INFO:
            imageSrc = require("../assets/images/teacher_clicker_info.png")
            break;
        case ImageConstants.YEELOW_BULLET:
            imageSrc = require("../assets/images/yellow-bullet.png")
            break;
        case ImageConstants.GREEN_BULLET:
            imageSrc = require("../assets/images/green-bullet.png")
            break;
        case ImageConstants.LIGHT_GREEN_BULLET:
            imageSrc = require("../assets/images/light-green-bullet.png")
            break;
        case ImageConstants.ORANGE_BULLET:
            imageSrc = require("../assets/images/orange-bullet.png")
            break;
        case ImageConstants.BLUE_BULLET:
            imageSrc = require("../assets/images/blue-bullet.png")
            break;
        case ImageConstants.RED_BULLET:
            imageSrc = require("../assets/images/red-bullet.png")
            break;
        case ImageConstants.INDIGO_BULLET:
            imageSrc = require("../assets/images/indigo-bullet.png")
            break;
         case ImageConstants.COPY_ICON:
            imageSrc = require("../assets/images/copy-icon.png")
            break;
        case ImageConstants.CLICKER_HAND_ICON:
            imageSrc = require("../assets/images/clicker-hand-icon.png")
            break;
         case ImageConstants.COUNTRY_CLOSE_ICON:
            imageSrc = require("../assets/images/close-icon.png")
            break;
             case ImageConstants.COUNTRY_CODE_SEARCH_ICON:
            imageSrc = require("../assets/images/country-code-search-icon.png")
            break;
             case ImageConstants.COUNTRY_DROPDWON_HEADER:
            imageSrc = require("../assets/images/country-dropdown-header.png")
            break;
             case ImageConstants.COUNTRY_DROPDWON_FOOTER:
            imageSrc = require("../assets/images/country-dropdown-footer.png")
            break;
        
        case ImageConstants.COUNTRY_CODE_DOWN_ARROW:
            imageSrc = require("../assets/images/country-code-down-arrow.png")
            break;
        case ImageConstants.COUNTRY_CODE_SEPARATOR:
            imageSrc = require("../assets/images/country-code-separator.png")
            break;
        case ImageConstants.PDF_DOWNLOAD_ICON:
            imageSrc = require("../assets/images/pdf-download.png")
            break;
        case ImageConstants.DESKTOP_ICON:
            imageSrc = require("../assets/images/desktop-icon.png")
            break;
        case ImageConstants.STUDENT_EXCERSIZE_IMAGE:
            imageSrc = require("../assets/images/student_excersize_image.png")
            break;
        case ImageConstants.GREAT_JOB_IMAGE:
            imageSrc = require("../assets/images/great_job_imag.png")
            break;
        case ImageConstants.FEEDBACK_1:
            imageSrc = require("../assets/images/feedback_1.png")
            break;
        case ImageConstants.FEEDBACK_2:
            imageSrc = require("../assets/images/feedback_2.png")
            break;
        case ImageConstants.FEEDBACK_3:
            imageSrc = require("../assets/images/feedback_3.png")
            break;

        case ImageConstants.THEME_CLOSE_ICON:
            imageSrc = require("../assets/images/theme-close-icon.png")
            break;

        case ImageConstants.EXPAND:
            imageSrc = require("../assets/images/expand.png")
            break;

        case ImageConstants.INCREASED_ICON:
            imageSrc = require("../assets/images/increased.png")
            break;

        case ImageConstants.EQUAL_ICON:
            imageSrc = require("../assets/images/equal.png")
            break;

        case ImageConstants.NEXT_ICON:
            imageSrc = require("../assets/images/next_icon.png")
            break;

        case ImageConstants.BACK_ICON_ORANGE:
            imageSrc = require("../assets/images/back_icon.png")
            break;

        case ImageConstants.NEW_BLACK_TICK_ICON:
            imageSrc = require("../assets/images/new_black_tick_icon.png")
            break;

        case ImageConstants.NEW_BLACK_CLOCK_ICON:
            imageSrc = require("../assets/images/new_black_clock_icon.png")
            break;


        case ImageConstants.QUESTION_BLUR:
            imageSrc = require("../assets/images/question_blur.png")
            break;

        case ImageConstants.TIMER_PAUSED:
            imageSrc = require("../assets/images/timer_paused.png")
            break;

        // case ImageConstants.QUESTION_COUNT_DOWN:
        //     imageSrc = require("../assets/images/question_countdown.gif")
        //     break;

            case ImageConstants.QUESTION_COUNT_DOWN:
            imageSrc = require("../assets/images/question_countdown_v1.gif")
            break;


        case ImageConstants.RANK_OTHERS:
            imageSrc = require("../assets/images/rank_others.png")
            break;
        case ImageConstants.RANK_THREE:
            imageSrc = require("../assets/images/rank_three.png")
            break;
        case ImageConstants.RANK_TWO:
            imageSrc = require("../assets/images/rank_two.png")
            break;
        case ImageConstants.RANK_ONE:
            imageSrc = require("../assets/images/rank_one.png")
            break;

        case ImageConstants.BLUE_FLAG_ICON:
            imageSrc = require("../assets/images/flag_icon_blue.png")
            break;


        case ImageConstants.WHITE_TICK_ICON:
            imageSrc = require("../assets/images/white_tick_icon.png")
            break;

        case ImageConstants.TRANSPARENT_IMAGE:
            imageSrc = require("../assets/images/transparent_image_new.png")
            break;

        case ImageConstants.GREEN_LEFT_ICON:
            imageSrc = require("../assets/images/green_left_icon.png")
            break;

        case ImageConstants.GREEN_RIGHT_ICON:
            imageSrc = require("../assets/images/green_right_icon.png")
            break;

        case ImageConstants.BLUE_LEFT_ICON:
            imageSrc = require("../assets/images/blue_left_icon.png")
            break;

        case ImageConstants.BLUE_RIGHT_ICON:
            imageSrc = require("../assets/images/blue_right_icon.png")
            break;


        case ImageConstants.CLICKER_ICON:
            imageSrc = require("../assets/images/clicker_icon.png")
            break;

        case ImageConstants.CLOSE_ICON_BLOCK_CROSS:
            imageSrc = require("../assets/images/close_icon_block_cross.png")
            break;

        case ImageConstants.DOWNLOAD_ICON_WHITE:
            imageSrc = require("../assets/images/download_icon_white.png")
            break;

        case ImageConstants.GRAY_CHECK_BOX:
            imageSrc = require("../assets/images/gray_check_box.png")
            break;
        case ImageConstants.BLOCK_TIMER:
            imageSrc = require("../assets/images/block_timer.png")
            break;
        case ImageConstants.GREEN_CHECK_BOX:
            imageSrc = require("../assets/images/green_check_box.png")
            break;
        case ImageConstants.LEADER_BOARD_ICON:
            imageSrc = require("../assets/images/leader_board_icon.png")
            break;
        case ImageConstants.HANBARGUR_NEW:
            imageSrc = require("../assets/images/hamburgur_new.png")
            break;
        case ImageConstants.WHITE_QUESTION_MARK:
            imageSrc = require("../assets/images/white_question_mark.png")
            break;
        case ImageConstants.WHITE_TIMER_ICON:
            imageSrc = require("../assets/images/white_timer_icon.png")
            break;

        case ImageConstants.LEADER_BOARD_BLOCK:
            imageSrc = require("../assets/images/leader_board_block.png")
            break;
        case ImageConstants.WHITE_CHECK_BOX:
            imageSrc = require("../assets/images/white_check_box.png")
            break;

        case ImageConstants.YELLOW_BULB:
            imageSrc = require("../assets/images/yellow_bulb.png")
            break;

        case ImageConstants.CLASS_ASSIGNMENT:
            imageSrc = require("../assets/images/class_assignment.png")
            break;
        case ImageConstants.TEACHER_ASSIGNMENT:
            imageSrc = require("../assets/images/teacher_assignment.png")
            break;
        case ImageConstants.CLASS_ASSIGNMENT_DETAILS:
            imageSrc = require("../assets/images/class_assignment_details.png")
            break;
        case ImageConstants.TEACHER_ASSIGNMENT_DETAILS:
            imageSrc = require("../assets/images/teacher_assignment_details.png")
            break;


        case ImageConstants.CHAPTER_COMPLETED_GIF:
            imageSrc = require("../assets/images/chapter-completed-gif/chapter-completed.gif")
            break;
        case ImageConstants.RED_BG_TICK_MARK:
            imageSrc = require("../assets/images/red-bg-tick-mark.png")
            break;
        case ImageConstants.PAUSE_BUTTON:
            imageSrc = require("../assets/images/pause-button.png")
            break;
        case ImageConstants.LC_BLUR:
            imageSrc = require("../assets/images/learning-content-blur.png")
            break;
        case ImageConstants.BULB_IMAGE:
            imageSrc = require("../assets/images/bulb_2.png")
            break;
        case ImageConstants.VERTICAL_LINE:
            imageSrc = require("../assets/images/vertical-line.png")
            break;
        case ImageConstants.CLOCK_IMAGE:
            imageSrc = require("../assets/images/clock-image.png")
            break;
        case ImageConstants.EXAM_PAD_ICON_BLOCK:
            imageSrc = require("../assets/images/exam-pad-image.png")
            break;
        case ImageConstants.QUESTION_MARK:
            imageSrc = require("../assets/images/question-mark-image.png")
            break;
        case ImageConstants.QUESTION_MARK_ICON:
            imageSrc = require("../assets/images/question-mark-icon.png")
            break;
        case ImageConstants.DATE_ICON:
            imageSrc = require("../assets/images/date-icon.png")
            break;

        case ImageConstants.EXAM_PAD_ICON_GRAY:
            imageSrc = require("../assets/images/exam-pad-icon-gray.png")
            break;
        case ImageConstants.CLOCK_ICON_GRAY:
            imageSrc = require("../assets/images/clock-icon-gray.png")
            break;

        case ImageConstants.RIGHT_ARROW_ORGANGE:
            imageSrc = require("../assets/images/right-arrow-orange.png")
            break;
        case ImageConstants.LEFT_ARROW_ORGANGE:
            imageSrc = require("../assets/images/left-arrow-orange.png")
            break;
        case ImageConstants.ASSESSMENT_FOOTER_IMAGE:
            imageSrc = require("../assets/images/assessment-footer-image.png")
            break;
        case ImageConstants.TITLE_DIVIDER:
            imageSrc = require("../assets/images/title-divider.png")
            break;
        case ImageConstants.HEADER_BG_IMAGE:
            imageSrc = require("../assets/images/header-bg-image.png")
            break;
        case ImageConstants.GREEN_BG_TICK_MARK:
            imageSrc = require("../assets/images/green-bg-tick-mark.png")
            break;
        case ImageConstants.RED_BG_CROSS_MARK:
            imageSrc = require("../assets/images/red-bg-cross-mark.png")
            break;
        case ImageConstants.BLACK_STUDENTS_COUNT_IMAGE:
            imageSrc = require("../assets/images/black-students-count-image.png")
            break;
        case ImageConstants.WHITE_STUDENTS_COUNT_IMAGE:
            imageSrc = require("../assets/images/white-students-count-image.png")
            break;
        case ImageConstants.CIRCLE_UP_ARROW:
            imageSrc = require("../assets/images/circle-up-arrow.png")
            break;
        case ImageConstants.CIRCLE_DOWN_ARROW:
            imageSrc = require("../assets/images/circle-down-arrow.png")
            break;
        case ImageConstants.BLACK_SUITCASE_ICON:
            imageSrc = require("../assets/images/black-suitcase-icon.png")
            break;

        case ImageConstants.WHITE_SUITCASE_ICON:
            imageSrc = require("../assets/images/white-suit-case-icon.png")
            break;
        case ImageConstants.BLUE_SUITCASE_ICON:
            imageSrc = require("../assets/images/blue-suit-case-icon.png")
            break;
        case ImageConstants.BLUE_MENU_ICON:
            imageSrc = require("../assets/images/blue-menu-icon.png")
            break;
        case ImageConstants.RED_STUDENT_ICON:
            imageSrc = require("../assets/images/red-student-icon.png")
            break;
        case ImageConstants.GREEN_CIRCLE_ICON:
            imageSrc = require("../assets/images/green-circle-icon.png")
            break;

        case ImageConstants.NO_WORKSHEET_IMAGE:
            imageSrc = require("../assets/images/no_worksheet_image.png")
            break;
        case ImageConstants.SHARE_ICON_BLACK:
            imageSrc = require("../assets/images/share_icon_black.png")
            break;
        case ImageConstants.VIDEO_PLAY_ICON_NEW:
            imageSrc = require("../assets/images/video-play-icon-new.png")
            break;
        case ImageConstants.SHARE_ICON:
            imageSrc = require("../assets/images/share-icon.png")
            break;

        case ImageConstants.EXPORT_TO_EXCEL:
            imageSrc = require("../assets/images/export_to_excel_icon.png")
            break;

        case ImageConstants.PEN_EDIT_ICON:
            imageSrc = require("../assets/images/pen-edit-icon.png")
            break;
        case ImageConstants.STUDENT_IMAGE:
            imageSrc = require("../assets/images/student-image.png")
            break;
        case ImageConstants.FILTER_HEADER:
            imageSrc = require("../assets/images/filter-header.png")
            break;
        case ImageConstants.FILTER_FOOTER:
            imageSrc = require("../assets/images/filter-footer.png")
            break;
        case ImageConstants.GREEN_TICK_ICON:
            imageSrc = require("../assets/images/green-tick-icon.png")
            break;
        case ImageConstants.FILTER_ICON_NEW:
            imageSrc = require("../assets/images/filter-icon.png")
            break;
        case ImageConstants.FILTER_ICON_ACTIVE:
            imageSrc = require("../assets/images/filter-active.png")
            break;
        case ImageConstants.IN_PROGRESS_ICON:
            imageSrc = require("../assets/images/in-progress-icon.png")
            break;
        case ImageConstants.SEARCH_ICON:
            imageSrc = require("../assets/images/search_icon.png")
            break;
        case ImageConstants.FILTER_ICON:
            imageSrc = require("../assets/images/filter_icon.png")
            break;
        case ImageConstants.DICTIONARY_IMAGE:
            imageSrc = require("../assets/images/dictionary-image.png")
            break;
        case ImageConstants.COMPLETION_DETAIL_REPORT:
            imageSrc = require("../assets/images/completion_detail_report.png")
            break;
        case ImageConstants.NMD_POSTER:
            imageSrc = require("../assets/images/nmd2023.jpeg")
            break;
        case ImageConstants.EVALUATION_DETAIL_REPORT:
            imageSrc = require("../assets/images/evaluation_detail_report.png")
            break;
        case ImageConstants.WRONG_QUESTIONS_DETAIL_REPORT:
            imageSrc = require("../assets/images/wrong_question_detail_report.png")
            break;
        case ImageConstants.ALL_QUESTIONS_DETAIL_REPORT:
            imageSrc = require("../assets/images/all_question_detail_report.png")
            break;
        case ImageConstants.ELLIPSE_BLUE:
            imageSrc = require("../assets/images/ellipse-blue.png")
            break;
        case ImageConstants.IMD_LOGO_2O23:
            imageSrc = require("../assets/images/imd_logo_2023.png")
            break;
        case ImageConstants.Q_A_ORANGE:
            imageSrc = require("../assets/images/q-a-orange.png")
            break;
        case ImageConstants.SCHOOL_PORTAL_MSF_BANNER:
            imageSrc = require("../assets/images/school-portal-msf-banner.png")
            break;
        case ImageConstants.GREEN_DOWNLOAD_ICON:
            imageSrc = require("../assets/images/green_download_icon.png")
            break;
        case ImageConstants.RECOMMENDATION_REPORT_CIRCLE:
            imageSrc = require("../assets/images/recommendation-report-circle.png")
            break;
        case ImageConstants.RECOMMENDED_ACTION:
            imageSrc = require("../assets/images/recommended-action.png")
            break;
        case ImageConstants.MEN_BULB_BLUE:
            imageSrc = require("../assets/images/men-bulb-blue.png")
            break;
        case ImageConstants.Q_A_CIRCLE:
            imageSrc = require("../assets/images/q-a-circle.png")
            break;
        case ImageConstants.EXAM_PAD_ICON:
            imageSrc = require("../assets/images/exam-pad-icon.png")
            break;
        case ImageConstants.HOMEWORK_EVALUATION:
            imageSrc = require("../assets/images/homework-evaluation.png")
            break;
        case ImageConstants.RECOMMENDATION_REPORT:
            imageSrc = require("../assets/images/recommendation-report.png")
            break;
        case ImageConstants.ALL_QUESTIONS:
            imageSrc = require("../assets/images/all-questions.png")
            break;
        case ImageConstants.WRONG_QUESTIONS:
            imageSrc = require("../assets/images/wrong-questions.png")
            break;
        case ImageConstants.BULB_BLUE:
            imageSrc = require("../assets/images/bulb-blue.png")
            break;
        case ImageConstants.GREEN_TICK_MARK:
            imageSrc = require("../assets/images/green-tick-mark.png")
            break;
        case ImageConstants.ACTIVITY_QUESTION_ICON:
            imageSrc = require("../assets/images/activity-question-icon.png")
            break;
        case ImageConstants.ACTIVITY_QUESTION_BG:
            imageSrc = require("../assets/images/activity-question-bg.png")
            break;
        case ImageConstants.CASE_STUDY_QUESTION_BG:
            imageSrc = require("../assets/images/case-study-question-bg.png")
            break;
        case ImageConstants.CASE_STUDY_QUESTION_ICON:
            imageSrc = require("../assets/images/case-study-question-icon.png")
            break;
        case ImageConstants.CHAPTER_ACTIVITY_ICON:
            imageSrc = require("../assets/images/chapter-activity-icon.png")
            break;
        case ImageConstants.ACTIVITY_BG:
            imageSrc = require("../assets/images/activity-bg.png")
            break;
        case ImageConstants.VIEW_MORE_IMAGE:
            imageSrc = require("../assets/images/view-more-image.png")
            break;
        case ImageConstants.CASE_STUDY_BG:
            imageSrc = require("../assets/images/case-study-bg.png")
            break;
        case ImageConstants.CASE_STUDY_ICON:
            imageSrc = require("../assets/images/case-study-icon.png")
            break;
        case ImageConstants.ALL_VIDEO_ECLIPSE:
            imageSrc = require("../assets/images/all-video-eclipse.png")
            break;
        case ImageConstants.ALL_VIDEO_POLYGON:
            imageSrc = require("../assets/images/all-video-polygon.png")
            break;

        case ImageConstants.VIDEO_DETAIL_POLYGON:
            imageSrc = require("../assets/images/video-detail-polygon.png")
            break;

        case ImageConstants.VIDEO_DETAIL_HEADER_IMAGE:
            imageSrc = require("../assets/images/video-detail-header-image.png")
            break;

        case ImageConstants.PLAY_ICON_ORANGE:
            imageSrc = require("../assets/images/play-icon-orange.png")
            break;

        case ImageConstants.SOLVED_EXAMPLE_BOOK_ICON:
            imageSrc = require("../assets/images/solved-example-book-icon.png")
            break;

        case ImageConstants.SOLVED_EXAMPLE_ECLIPSE:
            imageSrc = require("../assets/images/solved-example-eclipse.png")
            break;

        case ImageConstants.PLAY_ICON_BLUE_BG:
            imageSrc = require("../assets/images/play-icon-blue-bg.png")
            break;

        case ImageConstants.SOLVED_EXAMPLE_ICON:
            imageSrc = require("../assets/images/solved-example-icon.png")
            break;

        case ImageConstants.GRAY_CENTER_DIVIDER:
            imageSrc = require("../assets/images/gray-center-divider.png")
            break;

        case ImageConstants.GREEN_ECLIPSE_ICON:
            imageSrc = require("../assets/images/green-eclipse.png")
            break;
        case ImageConstants.BLUE_BOOK_ICON:
            imageSrc = require("../assets/images/blue-book-icon.png")
            break;

        case ImageConstants.VIDEO_PLAY_ICON:
            imageSrc = require("../assets/images/video-play-icon.png")
            break;
        case ImageConstants.BLUE_DIMOND_ICON:
            imageSrc = require("../assets/images/blue-dimond-icon.png")
            break;

        case ImageConstants.PK_POLYGON:
            imageSrc = require("../assets/images/pk-polygon.png")
            break;


        case ImageConstants.INFO_BLUE:
            imageSrc = require("../assets/images/info-blue.png")
            break;

        case ImageConstants.HOMEWORK_DIVIDER:
            imageSrc = require("../assets/images/homework-divider.png")
            break;

        case ImageConstants.BOOK_WITH_APPLE:
            imageSrc = require("../assets/images/book-with-apple.png")
            break;

        case ImageConstants.DOWNLOAD_ICON_BLUE_BG:
            imageSrc = require("../assets/images/download-icon-blue-bg.png")
            break;
        case ImageConstants.PLAY_ICON_GREEN_BG:
            imageSrc = require("../assets/images/play-icon-green-bg.png")
            break;

        case ImageConstants.WHITE_DOWN_ANGLE_ARROW:
            imageSrc = require("../assets/images/white-down-angle-arrow.png")
            break;
        case ImageConstants.WHITE_UP_ANGLE_ARROW:
            imageSrc = require("../assets/images/white-up-angle-arrow.png")
            break;

        case ImageConstants.OPTION_SEPARATOR:
            imageSrc = require("../assets/images/option-separator.png")
            break;

        case ImageConstants.TICK_MARK_ICON:
            imageSrc = require("../assets/images/tick-mark-icon.png")
            break;

        case ImageConstants.ASSIGN_CLASSWORK:
            imageSrc = require("../assets/images/assign-classwork.png")
            break;
        case ImageConstants.VIEW_CLASSWORK:
            imageSrc = require("../assets/images/view-classwork.png")
            break;
        case ImageConstants.ASSIGN_HOMEWORK:
            imageSrc = require("../assets/images/assign-homework-new.png")
            break;
        case ImageConstants.VIEW_HOMEWORK:
            imageSrc = require("../assets/images/view-homework-new.png")
            break;

        case ImageConstants.VIDEO_POSTER:
            imageSrc = require("../assets/images/video-poster.png")
            break;

        case ImageConstants.LIST_DIVIER:
            imageSrc = require("../assets/images/list-divider.png")
            break;

        case ImageConstants.CASE_STUDY_DOWNLOAD_ICON:
            imageSrc = require("../assets/images/case-study-download-icon.png")
            break;

        case ImageConstants.WHITE_DOWNLOAD_ICON:
            imageSrc = require("../assets/images/white-download-icon.png")
            break;
        case ImageConstants.BLACK_DOWNLOAD_ICON:
            imageSrc = require("../assets/images/black-download-icon.png")
            break;
        case ImageConstants.CW_LOGO_NEW:
            imageSrc = require("../assets/images/cw-logo-new.png")
            break;
        case ImageConstants.TICK_WHITE:
            imageSrc = require("../assets/images/tick-white.png")
            break;
        case ImageConstants.NEW_ASSESSMENT_BANNER:
            imageSrc = require("../assets/images/new-assessment-banner.png")
            break;
        case ImageConstants.TREE_ICN:
            imageSrc = require("../assets/images/tree-icn.png")
            break;
        case ImageConstants.PDF_ICON:
            imageSrc = require("../assets/images/pdf-icon.png")
            break;
        case ImageConstants.GRID_ICN:
            imageSrc = require("../assets/images/grid-icn.png")
            break;
        case ImageConstants.STEM_QUESTION_EXAMPLE:
            imageSrc = require("../assets/images/stem-question-sample.png")
            break;
        case ImageConstants.TREE_LINE_ICN_BLACK:
            imageSrc = require("../assets/images/tree-line-icn-black.png")
            break;
        case ImageConstants.TREE_LINE_SINGLE_ICN_BLACK:
            imageSrc = require("../assets/images/tree-line-single-icn-black.png")
            break;
        case ImageConstants.TREE_LINE_ICN:
            imageSrc = require("../assets/images/tree-line-icn.png")
            break;
        case ImageConstants.CAMERA:
            imageSrc = require("../assets/images/camera.png")
            break;
        case ImageConstants.SKILL_LOW_ICN:
            imageSrc = require("../assets/images/skill-level-low.png")
            break;
        case ImageConstants.SKILL_MEDIUM_ICN:
            imageSrc = require("../assets/images/skill-level-medium.png")
            break;
        case ImageConstants.SKILL_HIGH_ICN:
            imageSrc = require("../assets/images/skill-level-high.png")
            break;
        case ImageConstants.MARK_ICN:
            imageSrc = require("../assets/images/mark-icn.png")
            break;
        case ImageConstants.CHAPTER_ICN:
            imageSrc = require("../assets/images/chapter-icn.png")
            break;
        case ImageConstants.GIFTBOX:
            imageSrc = require('../assets/images/giftbox.png');
            break;
        case ImageConstants.CLAIM_SCHOLARSHIP_BANNER:
            imageSrc = require('../assets/images/claim-banner.png');
            break;
        case ImageConstants.HOMEWORK_SUCCESS_LEFT:
            imageSrc = require('../assets/images/homework-success-banner.png');
            break;
        case ImageConstants.HOMEWORK_SUCCESS_RIGHT:
            imageSrc = require('../assets/images/homework-success-banner-right.png');
            break;
        case ImageConstants.SUCCESS_GREEN:
            imageSrc = require('../assets/images/success-green.png');
            break;
        case ImageConstants.WEAKNESS_ICN:
            imageSrc = require('../assets/images/weakness-icn.png');
            break;
        case ImageConstants.STRENGTH_ICN:
            imageSrc = require('../assets/images/strength-icn.png');
            break;
        case ImageConstants.SCHOLAR_BLACK:
            imageSrc = require('../assets/images/scholar-black.png');
            break;
        case ImageConstants.SCHOLAR_WHITE:
            imageSrc = require('../assets/images/scholar-white.png');
            break;
        case ImageConstants.NOTIFICATION_BANNER:
            imageSrc = require('../assets/images/notification-banner.png');
            break;
        case ImageConstants.NOTIFICATION_HEADER_BG:
            imageSrc = require('../assets/images/notification-header-bg.png');
            break;
        case ImageConstants.FLUENT_CERTIFICATE:
            imageSrc = require('../assets/images/fluent-certificate.png');
            break;
        case ImageConstants.STUDENT_WINNERS_BG:
            imageSrc = require('../assets/images/imd-student-winners-bg.png');
            break;
        case ImageConstants.PEOPLE:
            imageSrc = require('../assets/images/people.png');
            break;
        case ImageConstants.PLAY_RED:
            imageSrc = require('../assets/images/play-red.png');
            break;
        case ImageConstants.NOTES:
            imageSrc = require('../assets/images/notes.png');
            break;
        case ImageConstants.VIDEO_BANNER:
            imageSrc = require('../assets/images/video-banner.png');
            break;
        case ImageConstants.XLS_BLUE:
            imageSrc = require('../assets/images/xls-blue.png');
            break;
        case ImageConstants.AD_BANNER_3:
            imageSrc = require('../assets/images/countingwell-banner-3.png');
            break;
        case ImageConstants.AD_BANNER_1:
            imageSrc = require('../assets/images/countingwell-banner-1.png');
            break;
        case ImageConstants.COUNTINGWELL_LOGO:
            imageSrc = require('../assets/images/countingwell-logo.png');
            break;
        case ImageConstants.AD_BANNER:
            imageSrc = require('../assets/images/ad-banner.png');
            break;
        case ImageConstants.INDIA_MAP_PIN:
            imageSrc = require('../assets/images/india-map-pin.png');
            break;
        case ImageConstants.INDIA_MAP_ICON:
            imageSrc = require('../assets/images/india-map-icn.png');
            break;
        case ImageConstants.CLONE_WHITE:
            imageSrc = require('../assets/images/clone-white.png');
            break;
        case ImageConstants.CLONE_ICON:
            imageSrc = require('../assets/images/clone-icn.png');
            break;
        case ImageConstants.PENCIL_ICON:
            imageSrc = require('../assets/images/pencil-icn.png');
            break;
        case ImageConstants.SIGNUP_SUCCESS_BANNER:
            imageSrc = require('../assets/images/signup-success-banner.png');
            break;
        case ImageConstants.SIGNUP_LOGO:
            imageSrc = require('../assets/images/signup-logo.png');
            break;
        case ImageConstants.MATHS_DAY_POS:
            imageSrc = require('../assets/images/math-day-pos.png');
            break;
        case ImageConstants.MATHS_DAY_POS_LOGO:
            imageSrc = require('../assets/images/math-day-pos-logo-new.png');
            break;
        case ImageConstants.DOWNLOAD_APP_ICON:
            imageSrc = require('../assets/images/download-app-icn.png');
            break;
        case ImageConstants.IMD_CLOCK_ICON:
            imageSrc = require('../assets/images/imd-clock-icn.png');
            break;
        case ImageConstants.IMD_CALENDAR_ICON:
            imageSrc = require('../assets/images/imd-calendar-icn.png');
            break;
        case ImageConstants.PRE_ASSESMENT_APP_ICON:
            imageSrc = require('../assets/images/pre-assesment-app-icn.png');
            break;
        case ImageConstants.ANDROID_DOWNLOAD:
            imageSrc = require('../assets/images/android-download.png');
            break;
        case ImageConstants.IOS_DOWNLOAD:
            imageSrc = require('../assets/images/ios-download.png');
            break;
        case ImageConstants.DOWN_CARET_DROPDOWN:
            imageSrc = require('../assets/images/down-caret-light.png');
            break;

        case ImageConstants.CW_LOGO:
            imageSrc = require('../assets/images/cw-logo.png');
            break;

        case ImageConstants.LOGO_WHITE:
            imageSrc = require('../assets/images/logo-white.png');
            break;

        case ImageConstants.LOGO_ICON:
            imageSrc = require('../assets/images/logo-icon.png');
            break;

        case ImageConstants.CW_IMAGE:
            imageSrc = require('../assets/images/cw-image.png');
            break;

        case ImageConstants.WELCOME:
            imageSrc = require('../assets/images/welcome.png');
            break;

        case ImageConstants.HEADER_LOGO:
            imageSrc = require('../assets/images/header-logo.png');
            break;

        case ImageConstants.USER_PLACEHOLDER:
            imageSrc = require('../assets/images/user.png');
            break;

        case ImageConstants.LOGOUT:
            imageSrc = require('../assets/images/logout.png');
            break;
            case ImageConstants.LOGOUT_RED:
            imageSrc = require('../assets/images/logout-red.png');
            break;

        case ImageConstants.REMOVE_CIRCLE:
            imageSrc = require('../assets/images/remove-circle.png');
            break;

        case ImageConstants.RED_REMOVE:
            imageSrc = require('../assets/images/red-remove.png');
            break;

        case ImageConstants.FORGOT_PASSWORD:
            imageSrc = require('../assets/images/forgot-password.png');
            break;

        case ImageConstants.DROPDOWN_ARROW:
            imageSrc = require('../assets/images/dropdown-arrow.png');
            break;

        case ImageConstants.REPORT_BG_1:
            imageSrc = require('../assets/images/report-background1.png');
            break;

        case ImageConstants.REPORT_BG_2:
            imageSrc = require('../assets/images/report-background2.png');
            break;

        case ImageConstants.LOADER_HEADER:
            imageSrc = require('../assets/images/loader-header.png');
            break;

        case ImageConstants.LOADER_FOOTER:
            imageSrc = require('../assets/images/loader-footer.png');
            break;

        case ImageConstants.LOADING_GIF:
            imageSrc = require('../assets/images/loading-gif/loading-gif.gif');
            break;

        case ImageConstants.PRE_LOADER_GIF:
            imageSrc = require('../assets/images/loading-gif/pre-loader-gif.gif');
            break;

        case ImageConstants.PROFILE_VECTOR:
            imageSrc = require('../assets/images/profile-vector.png');
            break;

        case ImageConstants.REPORT_WELCOME_ICON:
            imageSrc = require('../assets/images/teaching-quote.png');
            break;

        case ImageConstants.EXCEL_ICON:
            imageSrc = require('../assets/images/excel.png');
            break;

        case ImageConstants.CLEAR_ICON:
            imageSrc = require('../assets/images/clear.png');
            break;

        case ImageConstants.HR_LINE:
            imageSrc = require('../assets/images/line.png');
            break;

        case ImageConstants.NOTIFICATION_BELL_ACTIVE:
            imageSrc = require('../assets/images/notification-bell-active.png');
            break;

        case ImageConstants.DASHBOARD_IN_ACTIVE:
            imageSrc = require('../assets/images/dashboard-in-active.png');
            break;

        case ImageConstants.PERFORMANCE_IN_ACTIVE:
            imageSrc = require('../assets/images/performance-in-active.png');
            break;

        case ImageConstants.ADMIN_USER:
            imageSrc = require('../assets/images/admin-user.png');
            break;

        case ImageConstants.CONTACTS:
            imageSrc = require('../assets/images/contact-in-active.png');
            break;

        case ImageConstants.TEACHERS:
            imageSrc = require('../assets/images/teachers-in-active.png');
            break;

        case ImageConstants.CLASSES:
            imageSrc = require('../assets/images/classes-in-active.png');
            break;

        case ImageConstants.SETTINGS:
            imageSrc = require('../assets/images/settings-in-active.png');
            break;

        case ImageConstants.DASHBOARD_ACTIVE:
            imageSrc = require('../assets/images/dashboard-active.png');
            break;

        case ImageConstants.PERFORMANCE_ACTIVE:
            imageSrc = require('../assets/images/performance-in-active.png');
            break;

        case ImageConstants.ADMIN_USER_ACTIVE:
            imageSrc = require('../assets/images/admin-user-active.png');
            break;

        case ImageConstants.CONTACTS_ACTIVE:
            imageSrc = require('../assets/images/contact-active.png');
            break;

        case ImageConstants.CLASSES_ACTIVE:
            imageSrc = require('../assets/images/classes-active.png');
            break;

        case ImageConstants.SETTINGS_ACTIVE:
            imageSrc = require('../assets/images/settings-in-active.png');
            break;

        case ImageConstants.PROFILE_ACTIVE:
            imageSrc = require('../assets/images/profile-active.png');
            break;

        case ImageConstants.ONBOARD_TOP_RIGHT:
            imageSrc = require('../assets/images/graphic-1.png');
            break;

        case ImageConstants.ONBOARD_BOTTOM_RIGHT:
            imageSrc = require('../assets/images/graphic-2.png');
            break;

        case ImageConstants.CROSS:
            imageSrc = require('../assets/images/cross.png');
            break;

        case ImageConstants.CROSS_BLACK:
            imageSrc = require('../assets/images/cross-black.png');
            break;
        case ImageConstants.ADD:
            imageSrc = require('../assets/images/add.png');
            break;
        case ImageConstants.ADD_BLUE:
            imageSrc = require('../assets/images/add_blue.png');
            break;
        case ImageConstants.ADD_GRAY:
            imageSrc = require('../assets/images/add_gray.png');
            break;

        case ImageConstants.EDIT:
            imageSrc = require('../assets/images/edit.png');
            break;

        case ImageConstants.DELETE:
            imageSrc = require('../assets/images/del.png');
            break;

        case ImageConstants.BAR_CHART:
            imageSrc = require('../assets/images/bar-chart.png');
            break;

        case ImageConstants.CORRECT:
            imageSrc = require('../assets/images/correct.png');
            break;

        case ImageConstants.NO_RECORDS:
            imageSrc = require('../assets/images/no-records.png');
            break;

        case ImageConstants.ENVELOPE:
            imageSrc = require('../assets/images/envelope.png');
            break;

        case ImageConstants.MESSAGE:
            imageSrc = require('../assets/images/message.png');
            break;

        case ImageConstants.WHATSAPP:
            imageSrc = require('../assets/images/whatsapp.png');
            break;

        case ImageConstants.ENVELOPE_WHITE:
            imageSrc = require('../assets/images/envelope-white.png');
            break;

        case ImageConstants.MESSAGE_WHITE:
            imageSrc = require('../assets/images/message-white.png');
            break;

        case ImageConstants.WHATSAPP_WHITE:
            imageSrc = require('../assets/images/whatsapp-white.png');
            break;

        case ImageConstants.BACK_ICON:
            imageSrc = require('../assets/images/back-icon.png');
            break;

        case ImageConstants.ACTIVE_TICK:
            imageSrc = require('../assets/images/active-tick.png');
            break;

        case ImageConstants.INACTIVE_TICK:
            imageSrc = require('../assets/images/inactive-tick.png');
            break;

        case ImageConstants.RECT:
            imageSrc = require('../assets/images/rect.png');
            break;

        case ImageConstants.RECT_TICK:
            imageSrc = require('../assets/images/rect-tick.png');
            break;

        case ImageConstants.HOMEWORK_ACTIVE:
            imageSrc = require('../assets/images/homework-active.png');
            break;

        case ImageConstants.HOMEWORK_IN_ACTIVE:
            imageSrc = require('../assets/images/homework-in-active.png');
            break;

        case ImageConstants.STANDARD_HOMEWORK:
            imageSrc = require('../assets/images/standard-homework.png');
            break;

        case ImageConstants.ADAPTIVE_HOMEWORK:
            imageSrc = require('../assets/images/adaptive-homework.png');
            break;

        case ImageConstants.RIGHT_ARROW:
            imageSrc = require('../assets/images/right-arrow.png');
            break;

        case ImageConstants.COMPLETION_REPORT:
            imageSrc = require('../assets/images/completion-report.png');
            break;

        case ImageConstants.HOMEWORK_EVALUATION_REPORT:
            imageSrc = require('../assets/images/homework-evaluation-report.png');
            break;

        case ImageConstants.MOST_WRONGLY_ANSWERED:
            imageSrc = require('../assets/images/most-wrongly-answered.png');
            break;

        case ImageConstants.LEVEL_PROGRESSION_REPORT:
            imageSrc = require('../assets/images/level-progression-report.png');
            break;

        case ImageConstants.LEVEL_IMPROVEMENT_REPORT:
            imageSrc = require('../assets/images/level-improvement-report.png');
            break;

        case ImageConstants.DOWNLOAD_ICON:
            imageSrc = require('../assets/images/download-icon.png');
            break;

        case ImageConstants.DOWNLOAD_ICON_BLUE:
            imageSrc = require('../assets/images/download-icon-blue.png');
            break;

        case ImageConstants.EDIT_ICON:
            imageSrc = require('../assets/images/edit-icon.png');
            break;

        case ImageConstants.ARCHIVE:
            imageSrc = require('../assets/images/archive.png');
            break;


        case ImageConstants.REMAINDER:
            imageSrc = require('../assets/images/remainder.png');
            break;


        case ImageConstants.FILTER_SEPERATOR:
            imageSrc = require('../assets/images/filter-seperator.png');
            break;

        case ImageConstants.DELETE_WHITE:
            imageSrc = require('../assets/images/delete-white.png');
            break;

        case ImageConstants.HAMBARGUR:
            imageSrc = require('../assets/images/hambargur.png');
            break;

        case ImageConstants.WHITE_VIDEO_ICON:
            imageSrc = require('../assets/images/white-video-icon.png');
            break;

        case ImageConstants.HAMBARGUR1:
            imageSrc = require('../assets/images/hambergur1.png');
            break;

        case ImageConstants.HAMBARGUR2:
            imageSrc = require('../assets/images/hambargur2.png');
            break;


        case ImageConstants.INFO:
            imageSrc = require('../assets/images/info.png');
            break;

        case ImageConstants.INFO_GREY:
            imageSrc = require('../assets/images/info-grey.png');
            break;

        case ImageConstants.INFO1:
            imageSrc = require('../assets/images/info1.png');
            break;

        case ImageConstants.SEARCH:
            imageSrc = require('../assets/images/search.png');
            break;

        case ImageConstants.HEADER1:
            imageSrc = require('../assets/images/header-1.png');
            break;

        case ImageConstants.PDF:
            imageSrc = require('../assets/images/pdf.png');
            break;
        case ImageConstants.PDF_WHITE:
            imageSrc = require('../assets/images/pdf-white.png');
            break;
        case ImageConstants.CALENDAR_WHITE:
            imageSrc = require('../assets/images/calendar-white.png');
            break;
        case ImageConstants.PRINT:
            imageSrc = require('../assets/images/print.png');
            break;

        case ImageConstants.RECT_BLACK:
            imageSrc = require('../assets/images/rect-black.png');
            break;

        case ImageConstants.RECT_BLACK1:
            imageSrc = require('../assets/images/rect-black1.png');
            break;

        case ImageConstants.DRAG:
            imageSrc = require('../assets/images/drag.png');
            break;

        case ImageConstants.DRAG_LOADING:
            imageSrc = require('../assets/images/drag-loading.png');
            break;

        case ImageConstants.REPORT_CARD_INFO:
            imageSrc = require('../assets/images/report-card-info.png');
            break;

        case ImageConstants.EQUAL_ICON:
            imageSrc = require('../assets/images/equal-icon.png');
            break;

        case ImageConstants.UP_ARROW:
            imageSrc = require('../assets/images/up-arrow.png');
            break;

        case ImageConstants.DOWN_ARROW:
            imageSrc = require('../assets/images/down-arrow.png');
            break;

        case ImageConstants.MATCHING_ARROW:
            imageSrc = require('../assets/images/matching-arrow.png');
            break;

        case ImageConstants.DRAG_ICON:
            imageSrc = require('../assets/images/drag-icon.png');
            break;

        case ImageConstants.TEST_ACTIVE:
            imageSrc = require('../assets/images/test-active.png');
            break;

        case ImageConstants.TEST_INACTIVE:
            imageSrc = require('../assets/images/test-inactive.png');
            break;

        case ImageConstants.TEST_RESULTS_ACTIVE:
            imageSrc = require('../assets/images/test-results-active.png');
            break;

        case ImageConstants.TEACHERS_ACTIVE:
            imageSrc = require('../assets/images/teachers-active.png');
            break;

        case ImageConstants.MENU_ICON:
            imageSrc = require('../assets/images/menu-icon.png');
            break;

        case ImageConstants.ANSWER_ICON:
            imageSrc = require('../assets/images/answer-icon.png');
            break;

        case ImageConstants.SEPARATOR:
            imageSrc = require('../assets/images/separator.png');
            break;

        case ImageConstants.CORRECT_ANSWER:
            imageSrc = require('../assets/images/correct-answer.png');
            break;

        case ImageConstants.WRONG_ANSWER:
            imageSrc = require('../assets/images/wrong-answer.png');
            break;

        case ImageConstants.COMPLETION_REPORT_ACTIVE:
            imageSrc = require('../assets/images/completion-report-active.png');
            break;

        case ImageConstants.TEST_RESULTS_INACTIVE:
            imageSrc = require('../assets/images/test-results-inactive.png');
            break;

        case ImageConstants.MOST_WRONGLY_ANSWERED_ACTIVE:
            imageSrc = require('../assets/images/most-wrongly-answered-active.png');
            break;

        case ImageConstants.CARD_SEPARATOR:
            imageSrc = require('../assets/images/card-separator.png');
            break;

        case ImageConstants.GREEN_TICK:
            imageSrc = require('../assets/images/green-tick.png');
            break;

        case ImageConstants.GREEN_TICK_V1:
            imageSrc = require('../assets/images/green-tick-v1.png');
            break;

        case ImageConstants.GREEN_TICK_V2:
            imageSrc = require('../assets/images/green-tick-v2.png');
            break;

        case ImageConstants.CALENDAR:
            imageSrc = require('../assets/images/calendar.png');
            break;

        case ImageConstants.DOWNLOAD_ACTIVE:
            imageSrc = require('../assets/images/download-active.png');
            break;

        case ImageConstants.DATA_BAR:
            imageSrc = require('../assets/images/data-bar.png');
            break;

        case ImageConstants.EXAM_PAD:
            imageSrc = require('../assets/images/exam-pad.png');
            break;

        case ImageConstants.STUDENTS:
            imageSrc = require('../assets/images/students.png');
            break;

        case ImageConstants.VIDEOS:
            imageSrc = require('../assets/images/videos.png');
            break;

        case ImageConstants.QUOTE_LEFT:
            imageSrc = require('../assets/images/quote-left.png');
            break;

        case ImageConstants.WHITE_CLOSE_ICON:
            imageSrc = require('../assets/images/white-close-icon.png');
            break;

        case ImageConstants.QUOTE_RIGHT:
            imageSrc = require('../assets/images/quote-right.png');
            break;

        case ImageConstants.RIGHT_ARROW_WHITE:
            imageSrc = require('../assets/images/right-arrow-white.png');
            break;

        case ImageConstants.TICK:
            imageSrc = require('../assets/images/tick.png');
            break;

        case ImageConstants.RIGHT_ARROW_GRAY:
            imageSrc = require('../assets/images/right-arrow-gray.png');
            break;

        case ImageConstants.TICK_GREEN:
            imageSrc = require('../assets/images/tick-green.png');
            break;

        case ImageConstants.WRONG:
            imageSrc = require('../assets/images/wrong.png');
            break;

        case ImageConstants.RIGHT_ARROW_GRAY1:
            imageSrc = require('../assets/images/right-arrow-gray1.png');
            break;

        case ImageConstants.NO_DATA:
            imageSrc = require('../assets/images/no-data.png');
            break;

        case ImageConstants.FILTER:
            imageSrc = require('../assets/images/filter.png');
            break;

        case ImageConstants.BULB:
            imageSrc = require('../assets/images/bulb.png');
            break;

        case ImageConstants.TICK_GRAY:
            imageSrc = require('../assets/images/tick-gray.png');
            break;

        case ImageConstants.TICK_BLACK:
            imageSrc = require('../assets/images/tick-black.png');
            break;

        case ImageConstants.CLASS_SECTION_ICON:
            imageSrc = require('../assets/images/class-section-icn.png');
            break;

        case ImageConstants.CLASS_SECTION_ICON_WHITE:
            imageSrc = require('../assets/images/class-section-icn.png');
            break;
        case ImageConstants.GRAPHIC1:
            imageSrc = require('../assets/images/graphic-1.png');
            break;
        case ImageConstants.GRAPHIC2:
            imageSrc = require('../assets/images/graphic-2.png');
            break;

        case ImageConstants.KNOWLEDGE:
            imageSrc = require('../assets/images/knowledge.png');
            break;

        case ImageConstants.CALCULATION:
            imageSrc = require('../assets/images/calculation.png');
            break;

        case ImageConstants.MODELING:
            imageSrc = require('../assets/images/modeling.png');
            break;

        case ImageConstants.COMPREHENSION:
            imageSrc = require('../assets/images/comprehension.png');
            break;

        case ImageConstants.SIGNUP_WEB:
            imageSrc = require('../assets/images/signup-web.png');
            break;

        case ImageConstants.SIGNUP_MOBILE:
            imageSrc = require('../assets/images/signup-mobile.png');
            break;

        case ImageConstants.GULF_CALENDAR_ICON:
            imageSrc = require('../assets/images/gulf-calender.png');
            break;

        case ImageConstants.ARROW_DOWN_ANGLE:
            imageSrc = require('../assets/images/arrow_down_angle.png');
            break;

        case ImageConstants.ARROW_UP_ANGLE:
            imageSrc = require('../assets/images/arrow_up_angle.png');
            break;

        case ImageConstants.WHITE_TICK_MARK:
            imageSrc = require('../assets/images/white-tick-mark.png');
            break;

        case ImageConstants.EYE_ICON:
            imageSrc = require('../assets/images/eye-icon.png');
            break;

        case ImageConstants.CIRCLE_INFO_ICON:
            imageSrc = require('../assets/images/circle-info-icon.png');
            break;

        case ImageConstants.VIDEO_ICON:
            imageSrc = require('../assets/images/video-icon.png');
            break;

        case ImageConstants.BOOK_ICON:
            imageSrc = require('../assets/images/book-icon.png');
            break;



        case ImageConstants.RADIO_ACTIVE:
            imageSrc = require('../assets/images/radio-active.png');
            break;

        case ImageConstants.RADIO_INACTIVE:
            imageSrc = require('../assets/images/radio-inactive.png');
            break;

        case ImageConstants.EMAIL:
            imageSrc = require('../assets/images/email.png');
            break;

        case ImageConstants.SMS:
            imageSrc = require('../assets/images/sms.png');
            break;

        case ImageConstants.CLONE:
            imageSrc = require('../assets/images/clone.png');
            break;

        case ImageConstants.GULF_CALENDAR_ICON_1:
            imageSrc = require('../assets/images/gulf-calender-1.png');
            break;

        case ImageConstants.PRE_ASSESMENT_APP_ICON_1:
            imageSrc = require('../assets/images/pre-assesment-app-icn-1.png');
            break;

        case ImageConstants.ARROW_HORIZONTAL:
            imageSrc = require('../assets/images/arrow-horizontal.png');
            break;

        case ImageConstants.INFO_RED:
            imageSrc = require('../assets/images/info-red.png');
            break;

        case ImageConstants.INFO_RED_FILL:
            imageSrc = require('../assets/images/info-fill.png');
            break;

        case ImageConstants.DELETE_RED:
            imageSrc = require('../assets/images/del-red.png');
            break;

        case ImageConstants.EXTERNAL_LINK:
            imageSrc = require('../assets/images/external-link.png');
            break;

        case ImageConstants.INFO_CIRCLE:
            imageSrc = require('../assets/images/info-circle.png');
            break;
        case ImageConstants.SIGNUP_LOGO_RAMANUJAN:
            imageSrc = require('../assets/images/ramanujan.png');
            break;

        case ImageConstants.RECT_INACTIVE:
            imageSrc = require('../assets/images/rect-inactive.png');
            break;

        case ImageConstants.DIVIDER:
            imageSrc = require('../assets/images/divider.png');
            break;

        case ImageConstants.HELP_BLUE:
            imageSrc = require('../assets/images/help-blue.png');
            break;

        case ImageConstants.ELLIPSE:
            imageSrc = require('../assets/images/ellipse.png');
            break;

        case ImageConstants.ELLIPSE_ACTIVE:
            imageSrc = require('../assets/images/ellipse-active.png');
            break;

        case ImageConstants.ELLIPSE_INACTIVE:
            imageSrc = require('../assets/images/ellipse-inactive.png');
            break;


        case ImageConstants.CURRENCY:
            imageSrc = require('../assets/images/currency.png');
            break;

        case ImageConstants.REWARD1:
            imageSrc = require('../assets/images/reward-1.png');
            break;

        case ImageConstants.REWARD2:
            imageSrc = require('../assets/images/reward-2.png');
            break;

        case ImageConstants.REWARD3:
            imageSrc = require('../assets/images/reward-3.png');
            break;

        case ImageConstants.FLIPKART:
            imageSrc = require('../assets/images/third-party/flipkart.png');
            break;

        case ImageConstants.AMAZON:
            imageSrc = require('../assets/images/third-party/amazon.png');
            break;

        case ImageConstants.CROMA:
            imageSrc = require('../assets/images/third-party/croma.png');
            break;

        case ImageConstants.MPL:
            imageSrc = require('../assets/images/mpl.png');
            break;

        case ImageConstants.FLC:
            imageSrc = require('../assets/images/flc.png');
            break;
        case ImageConstants.MSF:
            imageSrc = require('../assets/images/msf-logo.png');
            break;
        case ImageConstants.SIGNUP_LOGO_MATHS_OLYMPIAD:
            imageSrc = require('../assets/images/math-olympaid-logo_thumbnail.png');
            break;
        case ImageConstants.USER1:
            imageSrc = require('../assets/images/user-1.png');
            break;

        case ImageConstants.BULLET_LIST:
            imageSrc = require('../assets/images/bullet-list-line.png');
            break;

        case ImageConstants.MAIL:
            imageSrc = require('../assets/images/mail.png');
            break;

        case ImageConstants.ONBOARDED:
            imageSrc = require('../assets/images/onboarded.png');
            break;
        case ImageConstants.INVITE_SENT:
            imageSrc = require('../assets/images/invite-sent.png');
            break;

        case ImageConstants.ONBOARDED_NEW:
            imageSrc = require('../assets/images/onboarded_new.png');
            break;
        case ImageConstants.INVITE_SENT_NEW:
            imageSrc = require('../assets/images/invite-sent-new.png');
            break;

    }

    return imageSrc;
}